// extracted by mini-css-extract-plugin
export default {"customer":"Customer_customer__FM3yC"};